import React from "react";
import { useNotification } from "../../../contexts/NotificationContext";
import NotificationsSlideIn from "./NotificationSlideIn";

const NotificationSlideInPortal = () => {
  const { notificationsVisible, setNotificationsVisible } = useNotification();

  return <NotificationsSlideIn visible={notificationsVisible} onClose={() => setNotificationsVisible(false)} />;
};

export default NotificationSlideInPortal;
